import { styled } from "@mui/material/styles";
const DetailsMain = styled("div")(({ theme }) => ({
  margin: "0 auto",
  marginTop: "30px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "80%",
  },
}));

const ButtonMain = styled("div")(({ theme }) => ({
  textAlign: "center",
  "& button": {
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: "18px",
    lineHeight: "27px",
    textAlign: "center",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    textTransform: "capitalize",
    padding: "0",
    background: "transparent",
    position: "relative",
    "&:hover": { background: "transparent" },
    "&.active": { color: "#0B0B0B", "&::after": { background: "#0B0B0B" } },
    "&::after": {
      content: "''",
      position: "absolute",
      bottom: "-10px",
      height: "2px",
      background: "#0B0B0B",
      width: "calc(100% + 40px)",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "15px",
      fontWeight: 600,
      "&.nonactivebtn": {
        color: "#AAAAAA",
        "&::after": { background: "#AAAAAA" },
      },
    },
  },
}));

export { DetailsMain, ButtonMain };
